module.exports = __webpack_public_path__ + "img/icon_xx4.19893b9.png";